/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { FaBarcode } from "react-icons/fa";
import { Button, Icon } from "antd-mobile";
import styled from "styled-components";
import * as _ from "underscore";
import * as checkoutSelector from "../../../selectors/checkout";
import Theme from "../../../utils/Theme";
import Color from "../../../utils/Color";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ServiceOptionsContainer = styled.div`
  width: 100%;
  display: block;
  background: white;
  border: 1px solid lightgray;
  box-shadow: 0 4px 6px -5px grey;
`;

const ServiceOptionsContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ServiceOptionsTitle = styled.span`
  display: flex;
  flex-direction: row;
  justify-conten: flex-start;
  align-items: center;
  text-align: start;
  align-self: stretch;
  font-size: 1em;
  padding: 10px 15px;
  color: ${Color.favouriteColor};
  border-bottom: 1px solid lightgrey;
`;

const ServiceTableContainer = styled.div`
  align-self: stretch;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 15px;
`;

const ServiceTableInputContainer = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const ServiceTableInput = styled.div`
  width: 55%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 5px;
  background: white;
  border: 1px solid
    ${props => (props.confirm ? Color.confirmedColor : "lightgrey")};
  color: ${props => (props.confirm ? Color.confirmedColor : "black")};
  box-shadow: none;
  outline: none;
`;

const StyledScanQrButton = styled.div`
  cursor: pointer;
  margin-left: 8px;
  border-radius: 50%;
  background: ${Theme.PrimaryColor};
  color: white;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledSubmitButton = styled.div`
  cursor: pointer;
  margin-left: 8px;
  background: ${Color.Tertiary};
  color: white;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledPaymentRowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledPaymentRowTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 35%;
  font-size: 0.9em;
`;

const StyledPaymentRowContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 45%;
  font-size: 0.9em;
  color: gray;
`;

const StyledPaymentRowButton = styled.div`
  align-self: flex-end;
  width: 20%;
`;

const StyledPaymentButton = styled(Button)`
  && {
    cursor: pointer;
    font-size: 0.85em
    border-radius: 0;
    color: white;
    background-color: ${Theme.PrimaryColor};
    box-shadow: 0 4px 6px -5px grey;
    border: unset;
  }
`;

const CheckoutAmountContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const CheckoutAmountTableContainer = styled.div`
  align-self: stretch;
  color: ${Color.secondaryTextColor};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 5px;
  margin-top: 8px;
`;

const CheckoutAmountRowContainer = styled.div`
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
`;

const CheckoutAmountRowHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-conten: flex-start;
  align-items: center;
  text-align: start;
`;

const CheckoutSummaryBreakLine = styled.div`
  height: 1px;
  width: 100%;
  background: lightgray;
  margin-top: 20px;
  margin-bottom: 10px;
`;

const CheckoutEarnPointTitle = styled(ServiceOptionsTitle)`
  font-size: 0.75em;
  color: ${Color.secondaryTextColor};
  padding: 0;
  border-bottom: unset;
`;

class CheckOutSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tableNo: null
    };
  }

  componentDidMount() {
    const { currentTable } = this.props;

    this.setState({
      tableNo: currentTable
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.currentTable !== this.props.currentTable) {
      this.setState({
        tableNo: nextProps.currentTable
      });
    }
  }

  onTableValueChanged = value => {
    this.setState({
      tableNo: value
    });
  };

  onTableNoSubmit = () => {
    const { onTableValueSubmit } = this.props;
    const { tableNo } = this.state;

    onTableValueSubmit && onTableValueSubmit(tableNo);
  };

  onPressUseEOrder = (amountDisplay, amount) => {
    const { onPressUseEOrder } = this.props;

    onPressUseEOrder && onPressUseEOrder(amountDisplay, amount);
  };

  onPressUseEWallet = (amountDisplay, amount) => {
    const { onPressUseEWallet } = this.props;

    onPressUseEWallet && onPressUseEWallet(amountDisplay, amount);
  };

  onPressClearPoint = () => {
    const { onPressClearPoint } = this.props;

    onPressClearPoint && onPressClearPoint();
  };

  onPressClearBalance = () => {
    const { onPressClearBalance } = this.props;

    onPressClearBalance && onPressClearBalance();
  };

  render() {
    const { tableNo } = this.state;
    const {
      intl,
      history,
      cartSummary,
      currency,
      currentTable,
      currentWallet,
      currentPoint,
      earnPoints,
      paymentTotal,
      deliveryEnabled
    } = this.props;
    const walletIsUsable = checkoutSelector.getWalletAttributeIsUsable(
      currentWallet
    );
    const walletUsable = checkoutSelector.getWalletUsable(currentWallet);
    const walletUsed = checkoutSelector.getWalletUsed(currentWallet);
    const walletIsApplied = checkoutSelector.getWalletAttributeIsApplied(
      currentWallet
    );
    const pointIsUsable = checkoutSelector.getPointAttributeIsUsable(
      currentPoint
    );
    const pointUsable = checkoutSelector.getPointUsable(currentPoint);
    const pointUsed = checkoutSelector.getPointUsed(currentPoint);
    const pointIsApplied = checkoutSelector.getPointAttributeIsApplied(
      currentPoint
    );

    return (
      <StyledContainer>
        {deliveryEnabled ? (
          <ServiceOptionsContainer>
            <ServiceOptionsContent>
              <ServiceOptionsTitle>
                <FormattedMessage
                  id="cart.service.options.title"
                  defaultMessage="How'd you want to get your food?"
                  description="Cart Service Options Title"
                />
              </ServiceOptionsTitle>
              <ServiceTableContainer>
                <FormattedMessage
                  id="cart.service.options.delivery.table.title"
                  defaultMessage="Your table no."
                  description="Cart Service Delivery Table Title"
                />
                <ServiceTableInputContainer>
                  <ServiceTableInput>
                    <StyledInput
                      confirm={
                        !_.isEmpty(currentTable) && currentTable === tableNo
                      }
                      value={tableNo}
                      onChange={v => this.onTableValueChanged(v.target.value)}
                      placeholder={intl.formatMessage({
                        id: "cart.service.options.delivery.table.placeholder",
                        defaultMessage: "table no",
                        description: "Cart Service Delivery Table Placeholder"
                      })}
                    />
                  </ServiceTableInput>
                  <StyledSubmitButton
                    className="opacity"
                    onClick={() => this.onTableNoSubmit()}
                  >
                    {intl.formatMessage({
                      id: "app.submit"
                    })}
                  </StyledSubmitButton>
                  <span style={{ marginLeft: "8px" }}>
                    <FormattedMessage id={"app.or"} />
                  </span>
                  <StyledScanQrButton
                    className={"opacity"}
                    onClick={() =>
                      history.push({
                        pathname: "/shop/scanner",
                        state: { returnUrl: "/shop/cart" }
                      })
                    }
                  >
                    <FaBarcode size={"1em"} />
                  </StyledScanQrButton>
                </ServiceTableInputContainer>
              </ServiceTableContainer>
            </ServiceOptionsContent>
          </ServiceOptionsContainer>
        ) : null}
        <ServiceOptionsContainer style={{ marginTop: "10px" }}>
          <ServiceOptionsContent>
            <ServiceOptionsTitle>
              <img
                src={require("../../../assets/icons/payment_options.png")}
                style={{ width: "18px" }}
              />
              <span style={{ marginLeft: "5px" }}>
                <FormattedMessage id="cart.payment.options.title" />
              </span>
            </ServiceOptionsTitle>
            <ServiceTableContainer>
              <StyledPaymentRowContainer>
                <StyledPaymentRowTitle>
                  <span>
                    <FormattedMessage id="cart.order.payment.point.title" />
                  </span>
                </StyledPaymentRowTitle>
                <StyledPaymentRowContent>
                  {pointUsable}{" "}
                  {intl.formatMessage({
                    id: "cart.order.payment.point.unit.title"
                  })}
                </StyledPaymentRowContent>
                <StyledPaymentRowButton>
                  {pointIsUsable ? (
                    <StyledPaymentButton
                      size="small"
                      activeStyle={{
                        background: Theme.ActivePrimary,
                        border: "unset"
                      }}
                      onClick={() =>
                        this.onPressUseEOrder(
                          pointUsable +
                            `${intl.formatMessage({
                              id: "cart.order.payment.point.unit.title"
                            })}`,
                          pointUsable
                        )
                      }
                    >
                      <FormattedMessage
                        id={
                          pointIsApplied
                            ? "cart.order.payment.button.change.title"
                            : "cart.order.payment.button.use.title"
                        }
                      />
                    </StyledPaymentButton>
                  ) : (
                    false
                  )}
                </StyledPaymentRowButton>
              </StyledPaymentRowContainer>
              <StyledPaymentRowContainer style={{ marginTop: "10px" }}>
                <StyledPaymentRowTitle>
                  <span>
                    <FormattedMessage id="cart.order.payment.wallet.title" />
                  </span>
                </StyledPaymentRowTitle>
                <StyledPaymentRowContent>
                  {currency} {walletUsable}
                </StyledPaymentRowContent>
                <StyledPaymentRowButton>
                  {walletIsUsable ? (
                    <StyledPaymentButton
                      size="small"
                      activeStyle={{
                        background: Theme.ActivePrimary,
                        border: "unset"
                      }}
                      onClick={() =>
                        this.onPressUseEWallet(
                          currency + " " + walletUsable,
                          walletUsable
                        )
                      }
                    >
                      <FormattedMessage
                        id={
                          walletIsApplied
                            ? "cart.order.payment.button.change.title"
                            : "cart.order.payment.button.use.title"
                        }
                      />
                    </StyledPaymentButton>
                  ) : (
                    false
                  )}
                </StyledPaymentRowButton>
              </StyledPaymentRowContainer>
            </ServiceTableContainer>
          </ServiceOptionsContent>
        </ServiceOptionsContainer>
        <CheckoutAmountContainer>
          <CheckoutAmountTableContainer>
            <CheckoutAmountRowContainer
              style={{ color: "black", fontWeight: "bold" }}
            >
              <span>
                {intl.formatMessage({
                  id: "cart.total.title"
                })}
                :
              </span>
              <span>
                {currency} {paymentTotal}
              </span>
            </CheckoutAmountRowContainer>
            <CheckoutSummaryBreakLine style={{ margin: "5px 0" }} />
            {!_.isEmpty(cartSummary)
              ? cartSummary.map((summary, index) => {
                  const summaryText = checkoutSelector.getSummaryText(summary);
                  const summaryName = checkoutSelector.getSummaryName(summary);

                  return (
                    <CheckoutAmountRowContainer key={index}>
                      <span>{summaryName}</span>
                      <span>{summaryText}</span>
                    </CheckoutAmountRowContainer>
                  );
                })
              : false}
            {pointIsApplied ? (
              <CheckoutAmountRowContainer>
                <CheckoutAmountRowHeaderContainer>
                  <Icon
                    onClick={() => this.onPressClearPoint()}
                    type="cross-circle-o"
                    color={Color.favouriteColor}
                    style={{
                      width: "13px",
                      height: "13px",
                      marginRight: "5px"
                    }}
                  />
                  <span>
                    <FormattedMessage id="cart.order.payment.point.used.title" />
                  </span>
                </CheckoutAmountRowHeaderContainer>
                <span>- {pointUsed}</span>
              </CheckoutAmountRowContainer>
            ) : (
              false
            )}
            {walletIsApplied ? (
              <CheckoutAmountRowContainer>
                <CheckoutAmountRowHeaderContainer>
                  <Icon
                    onClick={() => this.onPressClearBalance()}
                    type="cross-circle-o"
                    color={Color.favouriteColor}
                    style={{
                      width: "13px",
                      height: "13px",
                      marginRight: "5px"
                    }}
                  />
                  <span>
                    <FormattedMessage id="cart.order.payment.wallet.used.title" />
                  </span>
                </CheckoutAmountRowHeaderContainer>
                <span>
                  {" "}
                  - {currency} {walletUsed}
                </span>
              </CheckoutAmountRowContainer>
            ) : (
              false
            )}
            <CheckoutSummaryBreakLine />
            <CheckoutEarnPointTitle>
              <img
                src={require("../../../assets/icons/points.png")}
                style={{ width: "14px" }}
              />
              <span style={{ marginLeft: "5px" }}>
                <FormattedMessage
                  id="cart.checkout.earn.point.title"
                  values={{ points: earnPoints }}
                />
              </span>
            </CheckoutEarnPointTitle>
          </CheckoutAmountTableContainer>
        </CheckoutAmountContainer>
      </StyledContainer>
    );
  }
}

CheckOutSection.propTypes = {
  intl: PropTypes.object,
  history: PropTypes.object.isRequired,
  cartSummary: PropTypes.array,
  currency: PropTypes.string,
  currentTable: PropTypes.string,
  currentPoint: PropTypes.object,
  currentWallet: PropTypes.object,
  earnPoints: PropTypes.string,
  paymentTotal: PropTypes.string,
  deliveryEnabled: PropTypes.bool,
  onTableValueSubmit: PropTypes.func.isRequired,
  onPressUseEOrder: PropTypes.func.isRequired,
  onPressUseEWallet: PropTypes.func.isRequired,
  onPressClearPoint: PropTypes.func.isRequired,
  onPressClearBalance: PropTypes.func.isRequired
};

export default injectIntl(CheckOutSection);



// WEBPACK FOOTER //
// ./src/containers/CartPage/CheckOutSection/index.js